import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { modifyRequestDataBackoffice } from '../../services/axios-client/axeCommons';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import CauzioniRequest from '../cauzioni/CauzioniRequest';

/* Backoffice "Modifica Dati" for Fideiussioni e Cauzioni.

   Rather than a fifth hand-written copy of the same four steps, this loads the request through
   the shared /insurance-request/{token}/modify-data endpoint and hands the values to the very
   same wizard the broker uses. The wizard takes care of validation, the address autocomplete,
   the comune selectors and the document staging; all this screen decides is where the submit
   goes and what happens afterwards.

   Submitting creates a NEW request — it does not edit this one — which is how every other
   product's backoffice re-quote behaves. */
function BackOfficeCauzioni() {
  const { requestToken } = useParams();
  const navigate = useNavigate();

  const [prefill, setPrefill] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    modifyRequestDataBackoffice(requestToken)
      .then((res) => {
        if (cancelled) return;
        const data = res?.data?.data;
        // The shared client resolves 4xx into .then, so an unguarded read would hand the wizard
        // an empty object and present a blank form as though the request had no data.
        if (res.status !== 200 || !data?.sub_product || !data?.form_data) {
          setError(true);
          return;
        }
        setPrefill(data);
      })
      .catch(() => { if (!cancelled) setError(true); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [requestToken]);

  if (loading) return <PageLoading />;

  if (error || !prefill) {
    return (
      <div className="cauzioni-page">
        <p className="cauzioni-count cauzioni-error">
          Impossibile caricare i dati della richiesta. Riprova più tardi.
        </p>
      </div>
    );
  }

  return (
    <CauzioniRequest
      backoffice
      backofficeRequestToken={requestToken}
      initialSelection={{ sub: prefill.sub_product, risk: prefill.risk }}
      initialValues={prefill.form_data}
      // Stays inside the backoffice session, like condominioSubmitAnswers does.
      onSubmitted={(newToken) => navigate(`/backoffice/quote/${newToken}/surety-bonds/results`)}
    />
  );
}

export default BackOfficeCauzioni;
